// These error messages come from the API and indicate a save failure due to editing in another tab
export default function isTabLockError(error) {
  return !!(
    error &&
    (error.message === "Incorrect edit key provided" ||
      error.message === "Must provide a valid UUID as edit key" ||
      error.message === "No lock currently set on this piece")
  );
}
